import * as _ from "lodash";
import * as $ from "jquery";
import {SensorConfig} from "../models/SensorConfig";
import {CachingCollection} from "./_BaseCollection";


interface SensorConfigCollectionOptions {
    moduleId: number
}

export class SensorConfigCollection extends CachingCollection<SensorConfig> {

    model = SensorConfig;

    moduleId: number;

    constructor(initialModels: Object[] | any[], options: SensorConfigCollectionOptions) {
        super(initialModels, _.extend({model: SensorConfig}, options));
        this.moduleId = options.moduleId;
    }

    url = () => {
        return window.location.origin + '/api/v1/module/' + this.moduleId + '/sensor_config/';
    };

    batchSave(ajax) {
        ajax = ajax === undefined ? {} : ajax;

        $.ajax(_.extend({
            type: "POST",
            url: this.url(),
            data: JSON.stringify(this.toJSON()),
            dataType: 'json',
            contentType: "application/json; charset=utf-8"
        }, ajax));
    }

}



// WEBPACK FOOTER //
// ./srv/public/js/collections/SensorConfigs.ts